<h5 class="heading-6">{{ 'clients.credits.detail' | translate }}</h5>

<div class="gl-table__container">
  <gl-table
    [id]="listId"
    [dataSource]="dataSource"
    data-testid="creditsTable"
    [placeholder]="'actions.noResultTable' | translate"
    paginator
    (onDatasourceUpdate)="onDatasourceUpdate($event.detail.dataSource)"
  >
  </gl-table>
</div>

<lms-modal #modalCreditsEditor>
  <lms-credit-editor
    *ngIf="selectedSubscription"
    (saved)="onUpdateSubscription($event)"
    [client]="client"
    [subscription]="selectedSubscription"
  >
    <gl-button
      color-secondary
      [text]="'actions.cancel' | translate"
      (onClick)="cancelEditSubscription()"
      form-actions-before
    ></gl-button>
  </lms-credit-editor>
</lms-modal>
